import { FC } from "react";

export const DeactivationBannerTitle: FC = () => <span>This store is deactivated</span>;

export const DeactivationBannerBody: FC = () => (
  <>
    No new work packets will be identified or created. No updates will be made by our system to any work packets for
    this store.
  </>
);
